import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3fdffd6c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=3fdffd6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdffd6c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Atlas: require('/var/jenkins_home/workspace/prod-web-xfans/components/atlas.vue').default,Course: require('/var/jenkins_home/workspace/prod-web-xfans/components/course.vue').default,News: require('/var/jenkins_home/workspace/prod-web-xfans/components/news.vue').default,Activity: require('/var/jenkins_home/workspace/prod-web-xfans/components/activity.vue').default,Discussion: require('/var/jenkins_home/workspace/prod-web-xfans/components/discussion.vue').default})
